<template>
  <div class="real-auth-result" :class="{ check: isCheckApp, hunter: isHunterApp }">
    <img v-if="result === 'true'" :src="$setPicSize(successImg)" />
    <img v-if="result === 'false'" :src="$setPicSize(failImg)" />
    <div class="result-info">
      <header v-if="result === 'true'">恭喜您认证成功</header>
      <header v-if="result === 'false'">很遗憾认证失败</header>
      <div class="desc">{{ resInfo }}</div>
    </div>
    <div class="operation-area">
      <div v-for="ctx in buttonCtxes" :key="ctx.type" @click="doCommand(ctx)" :class="ctx.style">
        <span>{{ ctx.text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import setPicSize from '@zz-app/setPicSize'
import { lego } from '@zz-common/lego'
import { getuserauthcardinfo, getsdkcallbacktext } from '@api/resourceApi'
import { toast } from '../../native'
import { queryParams, getCookie, isCheckApp, isHunterApp } from '../../lib/utils'

const query = queryParams()
const zzv = query.zzv || getCookie('v')
const vers = zzv && zzv.split('.')
let lower54 = false
if (vers && ((vers[0] === 5 && vers[1] < 4) || vers[0] < 5) && !isCheckApp && !isHunterApp) {
  lower54 = true
}

export default {
  name: 'BusinessResult',
  data() {
    return {
      from: query.from || this.$route.query.from,
      code: query.code || this.$route.query.code,
      agreementNo: query.agreementNo || this.$route.query.agreementNo,
      authtype: query.authtype || this.$route.query.authtype || '', //  认证类型challenge代表二次挑战认证
      result: 'false',
      resInfo: '',
      buttonCtxes: [],
      isCheckApp,
      isHunterApp,
      successImg: 'f9436be4-ddfb-4f7b-8047-f0ae914e714c.png',
      failImg: '2980c180-8a0e-48e5-9ffb-ec7ad3ec4766.png'
    }
  },
  methods: {
    adapterOS() {
      if (isHunterApp) {
        this.successImg = 'n_v22b700e1a672d4efcb1b00ce4207c11c9.png'
        this.failImg = 'n_v23e94a6f9c8f34a5e98c65a7e12f7ffe2.png'
      }
    },
    $setPicSize(url) {
      return setPicSize(url, 500, 500)
    },
    adapterButtonCtxes(data) {
      let buttonData = data.map((b) => {
        return {
          cmd: b.type,
          targetUrl: b.mUrl,
          text: b.buttonDesc,
          style: b.style || 'normal'
        }
      })
      if (isCheckApp) {
        buttonData = buttonData.reverse().map((b) => {
          if (b.text.indexOf('退出') > -1) {
            b.text = '退出'
          }
          return b
        })
      }
      this.buttonCtxes = buttonData
    },
    doCommand(ctx) {
      lego.send({
        pagetype: 'ZZUP_BUSREALAUTH_RESULT',
        actiontype: 'CLICK',
        backup: {
          sourceCode: this.from,
          type: ctx.cmd
        }
      })
      if (ctx.cmd === 'close') {
        native.close()
      } else if (ctx.cmd === 'jump') {
        native.skipToUrl({
          targetUrl: ctx.targetUrl,
          needClose: '1'
        })
      } else if (ctx.cmd === 'reverify') {
        getuserauthcardinfo({
          agreementno: this.agreementNo,
          sourcecode: this.from
        })
          .then((res) => {
            localStorage.setItem('userCardNo', res.userCardNo)
            localStorage.setItem('userName', res.userName)
          })
          .catch((err) => {
            console.error(err)
            toast({
              msg: err.message || '获取用户实名失败',
              style: '2'
            })
          })
        native.skipToUrl({
          targetUrl: `https://feentry.zhuanzhuan.com/auth_face?clientid=BusinessRealauthCommitInfo&sourceCode=${this.from}&authtype=reverify`,
          newPageTitle: '商业实人认证',
          needClose: '1'
        })
      } else if (ctx.cmd === 'audit') {
        console.log('cmd', ctx.cmd)
        native.skipToUrl({
          targetUrl: `https://app.zhuanzhuan.com/zz/redirect/faceauthcheckredirect?sourceCode=${this.from}`,
          needClose: '1'
        })
      }
    }
  },
  created() {
    native.setTitle({
      title: '商业实人认证'
    })
    console.log('code', this.code)
    getsdkcallbacktext({
      sourcecode: this.from,
      code: this.code,
      agreementNo: this.agreementNo
    })
      .then((res) => {
        console.info(res)
        lego.send({
          pagetype: 'ZZUP_BUSREALAUTH_RESULT',
          actiontype: 'PAGE_SHOW',
          backup: {
            sourceCode: this.from,
            result: res.isPass
          }
        })
        this.result = res.isPass
        this.resInfo = res.copywriting
        this.adapterButtonCtxes(res.retButtons)
        if (this.result === 'true') {
          localStorage.removeItem('user_name')
          localStorage.removeItem('card_id')

          native.wrap('sendNotification')({
            name: 'ZZ_NOTIFICATION_REAL_CERTIFICATION_SUCCESS',
            args: JSON.stringify({ userId: getCookie('uid') })
          })
        }
      })
      .catch((err) => {
        console.error(err)
        toast({
          msg: err.errMsg || '提交失败',
          style: '2'
        })
      })
    this.adapterOS()
  },
  beforeRouteEnter(_to, _from, next) {
    next((vm) => {
      const pageLock = query.lock || vm.$route.query.lock
      if (!pageLock && lower54 && !isHunterApp) {
        native.skipToUrl({
          targetUrl: location.href.replace(/\?(.*)/, '?lock=1&$1'),
          needClose: '1'
        })
      }
    })
  }
}
</script>

<style lang="less" scoped>
  @import './Result.less';
</style>
